import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['visitors', 'dwell']

  update () {
    const metric = this.element.querySelector('input[name="sensorComparison-chartType"]:checked')?.value
    const targetType = this.element.querySelector('input[name="sensorComparison-targetType"]:checked')?.value || 'ExAllocation'
    const eventDayId = this.element.querySelector('#eventDay')?.value || ''

    this.visitorsTarget.hidden = metric === 'engaged_dwell'
    this.dwellTarget.hidden = metric !== 'engaged_dwell'
    this.dispatch('change', { detail: { params: { target_type: targetType, event_day_id: eventDayId } } })
  }
}
